import { Component } from "@angular/core"
import { ViewController } from "ionic-angular"

@Component({
  selector: "calendar-settings-page",
  templateUrl: "calendar.html",
})
export class CalendarSettingsPage {

  constructor(
    private viewCtrl: ViewController
  ) {}

  ionViewWillEnter() {

    this.viewCtrl.setBackButtonText("Ajustes")
  }
}



// WEBPACK FOOTER //
// ./src/pages/settings/calendar.ts